// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const PartsCoverageSearch = t.struct({
    coverage: t.maybe(t.String),
    effectiveDate: t.maybe(t.Number),
    partNumber: t.maybe(t.String),
    pin: t.maybe(t.String),
    warranty: t.maybe(t.String),
    warrantySubtype: t.maybe(t.String)
}, {
    name: 'PartsCoverageSearch',
    strict: true
});

export const getDefaultState = () => new PartsCoverageSearch({});

export default PartsCoverageSearch;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/parts-coverage-search.js